<script lang="ts" setup>

defineProps<{
    width?: number | string
    height?: number | string
}>();

</script>
<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 64.6 64.6"
        :width="width"
        :height="height"
        preserveAspectRatio="xMidYMid meet"
    >
        <path
            fill="rgb(255,153,0)"
            fill-opacity="1"
            d="M32.29999923706055,64.5999984741211 C32.29999923706055,64.5999984741211 22.206199645996094,42.393798828125 22.206199645996094,42.393798828125 C22.206199645996094,42.393798828125 -0.00009999999747378752,32.30009841918945 -0.00009999999747378752,32.30009841918945 C-0.00009999999747378752,32.30009841918945 22.206199645996094,22.20639991760254 22.206199645996094,22.20639991760254 C22.206199645996094,22.20639991760254 32.29990005493164,0.00009999999747378752 32.29990005493164,0.00009999999747378752 C32.29990005493164,0.00009999999747378752 42.393699645996094,22.20639991760254 42.393699645996094,22.20639991760254 C42.393699645996094,22.20639991760254 64.5999984741211,32.300201416015625 64.5999984741211,32.300201416015625 C64.5999984741211,32.300201416015625 42.393798828125,42.39390182495117 42.393798828125,42.39390182495117 C42.393798828125,42.39390182495117 32.29999923706055,64.5999984741211 32.29999923706055,64.5999984741211 C32.29999923706055,64.5999984741211 32.29999923706055,64.5999984741211 32.29999923706055,64.5999984741211z"
        />
    </svg>
</template>
